import type { SxProps } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { neutral } from "app/themes/colors";

type FieldLabelProps = {
  label: string;
  sx?: SxProps;
};
export default function FieldLabel({ label, sx }: FieldLabelProps) {
  return (
    <Typography
      variant="body1"
      sx={{
        textTransform: "uppercase",
        color: neutral[700],
        letterSpacing: 0.7,
        ...sx,
      }}
    >
      {label}
    </Typography>
  );
}
